import { PatientGroupQuery, PatientGroupUpdateEffectsCommand } from '@dreryk/egabinet-patient-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { PredefinedPatientGroupsUpdateFormBean } from './PredefinedPatientGroupsUpdateForm.types';
import { mapFormBeanToPatientGroupEffects } from './PredefinedPatientGroupsUpdateForm.utils';

type PredefinedPatientGroupsUpdateEffectsActionRenderProps = {
   updatePatientGroupEffects: (formData: PredefinedPatientGroupsUpdateFormBean) => Promise<void>;
};

type PredefinedPatientGroupsUpdateEffectsActionProps = {
   children: (renderProps: PredefinedPatientGroupsUpdateEffectsActionRenderProps) => JSX.Element;
   patientGroupId: number;
   onSuccess: VoidFunction;
};

export const PredefinedPatientGroupsUpdateEffectsAction = (
   props: PredefinedPatientGroupsUpdateEffectsActionProps
): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, PredefinedPatientGroupsUpdateFormBean>(
      (formData) => {
         const command = new PatientGroupUpdateEffectsCommand();
         command.id = props.patientGroupId;
         command.effects = mapFormBeanToPatientGroupEffects(formData);
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.changesHaveBeenSaved);
            refetchCqrsQuery(PatientGroupQuery);
            props.onSuccess();
         },
      }
   );

   return props.children({ updatePatientGroupEffects: executeAsync });
};
